import React, { createContext, useContext, ReactNode } from "react";
import { useChat } from "../hooks/useChat";

type ChatContextType = ReturnType<typeof useChat>;

const ChatContext = createContext<ChatContextType | undefined>(undefined);

/**
 * チャット（吹き出し・thread_id・送信中）を画面で 1 つにまとめる。
 * 以前はチャット欄（ChatArea）・URL の content からの自動開始（ChatPage）・レポートタブの生成（ReportTab）が
 * それぞれ useChat() を呼んでいたので、自動開始の吹き出しがチャット欄に出ず、チャット欄から答えると
 * thread_id が "" の別の会話になっていた（exploratory-tester-reports#46 F1・#215 F2）
 */
export const ChatProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const chat = useChat();
  return <ChatContext.Provider value={chat}>{children}</ChatContext.Provider>;
};

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (context === undefined) {
    throw new Error("useChatContext must be used within a ChatProvider");
  }
  return context;
};
